import { P2GText } from '@parcel2go/core-ui';
import AlertWithIcon from '../../AlertWithIcon';
import { P2GBox } from '@parcel2go/core-ui';
import { P2GButton } from '@parcel2go/core-ui';
import { SettingsCache } from '~/lib/consts/settings-cache';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  messages: string[];
  onClose: () => void;
}

export default function RenderCreateItemMessage(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const message = (message: string) => {
    switch (message) {
      case 'FILTERED':
        return (
          <P2GText variant="body2">
            <Trans
              t={t}
              i18nKey="FILTERED_MESSAGE"
              values={{
                filterName: SettingsCache.settings.SmartSend.Name
              }}
              defaults="Your items have been created, however this version of {{filterName}} cannot display them."
            />
          </P2GText>
        );
      default:
        return <P2GText variant="body2">{message}</P2GText>;
    }
  };

  return (
    <>
      <AlertWithIcon>{props.messages.map(message)}</AlertWithIcon>
      <P2GBox>
        <P2GButton onClick={props.onClose}>{t('CLOSE_BUTTON', { defaultValue: 'Close' })}</P2GButton>
      </P2GBox>
    </>
  );
}
